type Props = {
    className?: string
    onClick?: () => void
}

export const Rank = ({
    className,
    onClick
}: Props) => {
    return (
        <div onClick={onClick}>

            <svg className={className} width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_5011_99)">
                    <path d="M10.1525 1.44492C10.385 1.47867 10.485 1.7482 10.315 1.90804L9.365 2.76797L9.59 3.98672C9.6025 4.20703 9.3825 4.37578 9.1675 4.275L8.005 3.70078L6.8325 4.28203C6.6175 4.38281 6.375 4.21406 6.41 3.99609L6.635 2.775L5.685 1.90804C5.515 1.7482 5.615 1.47867 5.8475 1.44492L7.155 1.2682L7.745 0.148403C7.8525 -0.0536522 8.1575 -0.0452381 8.255 0.148403L8.845 1.2682L10.1525 1.44492ZM9.6 6C10.0425 6 10.4 6.33515 10.4 6.75V11.25C10.4 11.6648 10.0425 12 9.6 12H6.4C5.9575 12 5.6 11.6648 5.6 11.25V6.75C5.6 6.33515 5.9575 6 6.4 6H9.6ZM4 7.5C4.4425 7.5 4.8 7.83515 4.8 8.25V11.25C4.8 11.6648 4.4425 12 4 12H0.8C0.35825 12 0 11.6648 0 11.25V8.25C0 7.83515 0.35825 7.5 0.8 7.5H4ZM11.2 9.75C11.2 9.33515 11.5575 9 12 9H15.2C15.6425 9 16 9.33515 16 9.75V11.25C16 11.6648 15.6425 12 15.2 12H12C11.5575 12 11.2 11.6648 11.2 11.25V9.75Z" fill="#EF1B33"/>
                </g>
                <defs>
                <clipPath id="clip0_5011_99">
                    <rect width="16" height="12" fill="white"/>
                </clipPath>
                </defs>
            </svg>
        </div>
    )
}